import { FunctionComponent } from 'preact';
import { route, RoutableProps } from 'preact-router';
import { Layout } from '../components/layout';

export const ResetPasswordDonePage: FunctionComponent<RoutableProps> = () => {
  return (
    <Layout title="Passwort geändert" subtitle="Du kannst dich jetzt mit dem neuen Passwort anmelden.">
      <button class="btn mt-md" onClick={() => route('/login', true)}>
        Zur Anmeldung
      </button>
    </Layout>
  );
};
